export default __webpack_public_path__ + "static/14-517e5a292730888ccfe305b3e994a135.webp";